export const DEVICE = {
  DESKTOP: "desktop",
  MOBILE: "mobile",
  TABLET: "tablet",
};

export const APP_MODE = {
  KIOSK: "kiosk",
  WEB: "web",
};

export const PRODUCT_NAME = "Fairgate - availio";
